import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './Price.module.css'
import styleNames from '../../utils/styleNames'
import FormActions from '../../actions/FormActions'

import { Select } from '../index'

export default class Price extends Component {
  static propTypes = {
    disabled : PropTypes.bool,
    fixedPrice: PropTypes.string,
    selectedPriceType: PropTypes.string
  }
  static defaultProps = {
    fixedPrice: '-'
  }
  _onRadioButtonPressed (name) {
    FormActions.selectPriceType(name)
  }

  render () {
    return (
      <div className={styles['price-container']}>
        <span className={styleNames(styles, this.props.disabled ? 'has-error error' : 'no-error')}><div />{this.props.disabled ? 'Destination krävs' : ''}</span>
        <div className={styles.col}>
          <label>
          Taxameter
          </label>
          <Select
            checked={this.props.selectedPriceType === 'taxameter'}
            name="priceType"
            onClick={this._onRadioButtonPressed.bind(this, 'taxameter')}
            type="radio" />
        </div>
        <div className={styles.col}>
          <label>
          Fast pris <strong>{this.props.fixedPrice} kr</strong>
          </label>
          <Select
            checked={this.props.selectedPriceType === 'fixedPrice'}
            disabled={this.props.disabled}
            name="priceType"
            onClick={this._onRadioButtonPressed.bind(this, 'fixedPrice')}
            type="radio" />
        </div>
      </div>
    )
  }
}
